class ArrayUtils {
    public contains<T>(array: T[], needle: T): boolean {
        return array.indexOf(needle) > -1;
    }
}

export default new ArrayUtils();